/**
 * Centralized API Configuration
 * This file contains all API-related configuration settings
 * to avoid duplication across multiple API files.
 */

export const API_URL ="https://abjrfh64q6.execute-api.ap-south-1.amazonaws.com/LiveMode";

// export const API_URL ="http://127.0.0.1:3000";


  // All Demo Link - Need to updated later
  export const SOCIAL_MEDIA_LINKS = {
  facebook: "https://www.facebook.com/profile.php?id=61584405770747",
  instagram: "https://www.instagram.com/oruclicks/",
  linkedin: "https://www.linkedin.com/company/oruclicks/",
  whatsapp: null, // Coming soon
  youtube: null, // Coming soon
};

export const COMPANY_INFO = {
  name: "OruClick",
  description:
    "The ultimate AI-powered social media automation platform. Streamline your content, amplify your reach, and grow your brand with cutting-edge technology.",
  email: "contact@oruclicks.com",
  founded: new Date().getFullYear(),
};

export const FOOTER_LINKS = {
  product: [
    { label: "Features", url: "/features" },
    { label: "Pricing", url: "/pricing" },
    { label: "API", url: "/api" },
    { label: "Integrations", url: "/integrations" },
    { label: "Updates", url: "/updates" },
  ],
  company: [
    { label: "About Us", url: "/about" },
    { label: "Careers", url: "https://www.career.oruclicks.com" },
    { label: "Blog", url: "/blog" },
    { label: "Press Kit", url: "/press" },
    { label: "Contact", url: "/contact" },
  ],
  resources: [
    { label: "Help Center", url: "/help" },
    { label: "Community", url: "/community" },
    { label: "Tutorials", url: "/tutorials" },
    { label: "Webinars", url: "/webinars" },
    { label: "Status", url: "/status" },
  ],
  legal: [
    { label: "Privacy Policy", url: "https://www.oruclicks.com/privacy-policy" },
    { label: "Terms of Service", url: "https://www.oruclicks.com/termsandconditions" },
    { label: "Cookie Policy", url: "/cookies" },
    { label: "GDPR", url: "/gdpr" },
  ],
};

export const APP_CONFIG = {
  // Product Information
  PRODUCT_NAME: "OruClick",
  PRODUCT_VERSION: "1.0.0",
  
  // API Configuration
  DEFAULT_CLIENT_ID: "OruClick",
  
  // Social Media Limits
  MAX_IMAGE_SIZE: 10 * 1024 * 1024, // 10MB
  MAX_VIDEO_SIZE: 50 * 1024 * 1024, // 50MB
  MAX_IMAGES: 10,
  MAX_VIDEOS: 5,
  
  // Date/Time Formats
  DATE_FORMAT: "YYYY-MM-DD",
  TIME_FORMAT: "HH:mm:ss",
  DATETIME_FORMAT: "YYYY-MM-DDTHH:mm:ss",
  
  // UI Configuration
  SNACKBAR_DURATION: 4000,
  
  // Storage Keys
  STORAGE_KEYS: {
    CLIENT_ID: "clientId",
    USER_TOKEN: "userToken",
    USER_DATA: "userData",
  },
};

// Export individual values for convenience
export const {
  PRODUCT_NAME,
  PRODUCT_VERSION,
  DEFAULT_CLIENT_ID,
  MAX_IMAGE_SIZE,
  MAX_VIDEO_SIZE,
  MAX_IMAGES,
  MAX_VIDEOS,
  STORAGE_KEYS,
} = APP_CONFIG;

export default APP_CONFIG;